var map = {
	"./american football.png": 9854,
	"./axe.png": 116,
	"./bag.png": 8798,
	"./balloon.png": 8660,
	"./baseball bat.png": 7448,
	"./beer bottle.png": 875,
	"./big hammer.png": 8375,
	"./botal.png": 8607,
	"./box.png": 3567,
	"./broom.png": 9411,
	"./degree scroll.png": 4278,
	"./double sided axe.png": 4999,
	"./egg.png": 5043,
	"./football.png": 2948,
	"./hammer.png": 8235,
	"./keyboard.png": 8766,
	"./lamp 1.png": 9913,
	"./lamp 2.png": 8360,
	"./lamp 3.png": 5164,
	"./magic wand.png": 9081,
	"./mail.png": 7389,
	"./package courier.png": 2959,
	"./paint bucket.png": 3464,
	"./pillow.png": 6315,
	"./pot.png": 9312,
	"./shank.png": 4354,
	"./sleeping bag.png": 5583,
	"./small tree pot.png": 7808,
	"./snow.png": 2186,
	"./special egg.png": 2245,
	"./tiffin bag.png": 7942,
	"./volleyball.png": 1030,
	"./watermelon.png": 6038,
	"./wine bottle.png": 1101
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3353;